module.exports = __webpack_public_path__ + "static/media/Rovan Cam 02.f21a6691.webp";